var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"common-card-container"},[_c('cardList',{attrs:{"card-list":_vm.commonCardMap,"value-cards":_vm.valueCards}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }